import React from 'react';
import { FadeIn } from './FadeIn';
import { Clock } from 'lucide-react';
export function PainPoint() {
  return <section className="py-16 md:py-24 px-4 bg-navy-800" data-id="element-134">
      <div className="max-w-3xl mx-auto" data-id="element-135">
        <FadeIn data-id="element-136">
          <div className="bg-navy-900 border border-navy-700 rounded-2xl p-8 md:p-12 shadow-xl relative overflow-hidden" data-id="element-137">
            {/* Decorative accent */}
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-amber-500 to-transparent opacity-50" data-id="element-138"></div>

            <div className="flex items-center gap-4 mb-8" data-id="element-139">
              <div className="p-3 bg-navy-800 rounded-full text-amber-500" data-id="element-140">
                <Clock size={32} data-id="element-141" />
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-white" data-id="element-142">
                ¿Te despertaste a las 3:14 AM otra vez?
              </h2>
            </div>

            <div className="space-y-6 text-lavender-200 text-lg md:text-xl leading-relaxed" data-id="element-143">
              <p data-id="element-144">
                Mientras el resto del mundo duerme, tú estás ahí, mirando el
                techo, haciendo cálculos matemáticos sobre cuántas horas de
                sueño te quedan si logras dormirte "ahora mismo".
              </p>
              <p className="font-medium text-white" data-id="element-145">
                Esa ansiedad en el pecho no es tu culpa. No es solo "la edad".
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}